// import { useEffect, useState } from "react";
// import Foot from "../../components/Footer/Foot";
import Hero from "../../components/Hero/Hero";
// import Nav from "../../components/Navbar/Nav";
import Two from "../../components/Two/Two";
// import axios from"axios";
// import Covid from "../../components/Covid/Covid";
import Sum from "../../components/Summary/Sum";

function Indonesia(){

      //buat key API Covid Indonesia
    //   const URL = "https://covid19.mathdro.id/api/countries/indonesia/confirmed";

    // //   const [covids, setCovid] =  useState("");

    //   useEffect(async() => {
    //         //fetch data dari axios
    //         const response = await axios(URL);
    //         // console.log(response.data);

           
    //         setCovid(response.data);

    //   } , []);

    //   console.log(covids);

    return(

        //merender dari react-router
        <div>
            <Hero />
            <Two  />
            {/* <Nav /> */}
            {/* <h2>Home Page Indonesia</h2> */}
            {/* <Foot /> */}
            <Sum />
           
           
           
            
        </div>
    )
}

export default Indonesia;